// 🔹 WhatsappInquiryComponent.js
import React, { useState } from 'react';
import WhatsappButton from './WhatsappButton';


const WhatsappInquiryComponent = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      <div onClick={() => setShow(true)} style={{ position: "fixed", bottom: "22px", left: "25px", zIndex: 1055 }}>
        <WhatsappButton />
      </div>
    </>
  );
};

export default WhatsappInquiryComponent;
